var O = /* @__PURE__ */ ((C) => (C.Open = "OPEN", C.Close = "CLOSE", C.Focus = "FOCUS", C.Blur = "BLUR", C.Change = "CHANGE", C.Submit = "SUBMIT", C.Back = "BACK", C))(O || {}), u = /* @__PURE__ */ ((C) => (C.SelectSuggestion = "SELECT_SUGGESTION", C.RemoveSuggestion = "REMOVE_SUGGESTION", C))(u || {});
export {
  O as SearchNavigationEvent,
  u as SearchSuggestionsEvent
};
